export const rerunCallTracking  = () => {
    if (window["__ctm"]) {
        window["__ctm"].main.runNow(document.body)
    }
}
